<template>
  <div>
    <el-popover
      v-if="isEditable"
      placement="bottom"
      width="200"
      :open-delay="0"
      trigger="click"
      ref="popover">

      <div class="clearfix mt-2">
        Foreground color:
        <el-color-picker
          style="float: right"
          size="small"
          v-model="fgColor"
          @input="onUpdate"
          :predefine="predefineColors" />
      </div>

      <div class="clearfix mt-2">
        Background color:
        <el-color-picker
          style="float: right"
          size="small"
          v-model="bgColor"
          @input="onUpdate"
          :predefine="predefineColors" />
      </div>

      <div class="clearfix mt-2 pb-2">
        Symbol:
        <IconSelector v-model="symbol" @input="onUpdate" class="mt-2"/>
      </div>

      <el-button class="btn-block ml-0" size="mini" @click.prevent="onUpdateAndClose()">
        Close
      </el-button>

      <!--
      <pre>
symbol: {{symbol}}
fg: {{fgColor}}
bg: {{bgColor}}
      </pre>
      -->

      <!-- TODO: Also show emoji selector -->
      <!-- https://github.com/jm-david/emoji-mart-vue -->

      <div
        v-if="symbol"
        slot="reference"
        class="round-icon"
        :style="{
          cursor: 'pointer',
          backgroundColor: bgColor,
          float: 'left',
          margin: '0 10px 0 0'
        }">
        <font-awesome-icon :icon="symbol" :color="fgColor" />
      </div>
      <div v-else>
        NO ICON
      </div>
    </el-popover>
    <template v-else>
      <!-- doppelt, move to template function -->
      <div
        v-if="symbol"
        slot="reference"
        class="round-icon"
        :style="{
          backgroundColor: bgColor,
          float: 'left',
          margin: '0 10px 0 0'
        }">
        <font-awesome-icon :icon="symbol" :color="fgColor" />
      </div>
      <div v-else>
        NO ICON
      </div>
    </template>
  </div>
</template>

<script>
import { COLOR_LIST as predefineColors } from '@/misc/colors'
import IconSelector from '@/components/Elements/IconSelector'

export default {
  props: {
    value: {},
    isEditable: { default: true }
  },
  data: () => ({
    predefineColors: predefineColors,
    symbol: null,
    fgColor: null,
    bgColor: null,
  }),
  watch: {
    value: {
      handler( newValue ) {
        if (newValue) {
          this.symbol = newValue.symbol || null;
          this.fgColor = newValue.fgColor || null;
          this.bgColor = newValue.bgColor || null;
        }
      },
      immediate: true
    }
  },
  methods: {
    onOpenCommitmentModal() {
      console.log("onOpenCommitmentModal");
    },
    onUpdate() {
      const icon = {
        symbol: this.symbol,
        fgColor: this.fgColor,
        bgColor: this.bgColor
      }
      this.$emit('input', icon)
    },
    onUpdateAndClose() {
      this.onUpdate();
      this.$refs.popover.doClose()
    }
  },
  components: {
    IconSelector
  }
}
</script>
